import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { CompleteInventoryStockTake$Params } from 'src/api/generated/fn/inventory/complete-inventory-stock-take';
import { GetInventory$Params } from 'src/api/generated/fn/inventory/get-inventory';
import { GetInventoryStockTake$Params } from 'src/api/generated/fn/inventory/get-inventory-stock-take';
import { InventoryDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/Inventory/inventory-dto';
import { CompleteInventoryStockTakeDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/InventoryStockTake/complete-inventory-stock-take-dto';
import { InventoryStockTakeDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/InventoryStockTake/inventory-stock-take-dto';
import { InventoryService } from 'src/api/generated/services';
import { InventoryActionStatus } from 'src/app/pos-panel/enums/inventory-action-status.enum';
import { CurrentVenueHelperService } from 'src/app/share-modul/services/current-venue-helper/current-venue.helper.service';

@Component({
  selector: 'app-stock-take-input',
  templateUrl: './stock-take-input.component.html',
  styleUrls: ['./stock-take-input.component.scss']
})
export class StockTakeInputComponent implements OnInit, OnDestroy {

  venueId: string;
  inventoryId: string;
  stockTakeId: string;
  inventory: InventoryDto;

  stockTake: InventoryStockTakeDto = {} as InventoryStockTakeDto;
  InventoryActionStatus = InventoryActionStatus;
  form: FormGroup;
  timezoneOffset: any;

  venueIdUpdateSubscription: Subscription;

  constructor(private inventoryService: InventoryService,
              private router: Router,
              private route: ActivatedRoute,
              private currentVenueHelper: CurrentVenueHelperService,
              private confirmationService: ConfirmationService, 
              public translate: TranslateService,
              private formBuilder: FormBuilder,
              private messageService: MessageService) {

   }

  ngOnInit(): void {
    this.form = new FormGroup({
      items: new FormArray([])
    }); 
    this.route.params.subscribe(params => {
      if (params['venue-id'] != null) {
        this.venueId = params['venue-id'];
        this.currentVenueHelper.updateCurrentVenueIdDropdown(params['venue-id']);
        this.currentVenueHelper.getTimezone().subscribe(tzOffset => this.timezoneOffset = tzOffset);
      }
      if (params['inventory-id'] != null && params['stock-take-id'] != null) {
        this.inventoryId = params['inventory-id'];
        this.stockTakeId = params['stock-take-id'];

        const inventoryParams: GetInventory$Params = { inventoryId: this.inventoryId };
        this.inventoryService.getInventory(inventoryParams).subscribe(response => this.inventory = response);
        
        const paramsStockTake: GetInventoryStockTake$Params = { inventoryId: this.inventoryId, stockTakeId: this.stockTakeId };
        this.inventoryService.getInventoryStockTake(paramsStockTake).subscribe( response =>  {
          this.stockTake = response;
          this.createForm();
         });
      }
    });
  }

  private createForm(): void {
    this.form = new FormGroup({
      items: this.formBuilder.array([])
    });   
    this.stockTake.lineItems?.forEach(item => this.items.push(this.createTableRow()));
  }

  get items(): FormArray {
    return this.form.get('items') as FormArray;
  }
  
  getItemControls(index: number){
    return (this.items.controls[index] as FormGroup)
  }

  private createTableRow(): FormGroup {
    return this.formBuilder.group({
      item: new FormControl('', {
        validators: []
      }),
      quantityCounted: new FormControl('', {
        validators: [Validators.required]
      })
    });
  }

  completeStockTake(){
    if(this.form.valid){
      this.confirmationService.confirm({
        header: this.translate.instant('STOCK_TAKE.CONFIRMATION_DIALOG_COMPLETE_STOCK_TAKE_TITLE'),
        message: this.translate.instant('STOCK_TAKE.CONFIRMATION_DIALOG_COMPLETE_STOCK_TAKE_QUESTION'),
        acceptLabel: this.translate.instant('YES'),
        rejectLabel: this.translate.instant('NO'),
        defaultFocus: "reject",
        acceptButtonStyleClass: 'soc-confirmation-dialog dialog-btn constructive-btn',
        rejectButtonStyleClass: 'soc-confirmation-dialog dialog-btn reject-btn',
        accept: () => {
          this.stockTake.lineItems?.forEach((item, index) => item.quantityCounted = this.form.getRawValue().items[index]['quantityCounted']);
          const dto: CompleteInventoryStockTakeDto = { lineItems: this.stockTake.lineItems }
          const params: CompleteInventoryStockTake$Params = { inventoryId: this.inventoryId, stockTakeId: this.stockTakeId, body: dto };
          this.inventoryService.completeInventoryStockTake(params).subscribe({
              next: response => {
                this.messageService.add( { severity: 'success', summary: 'Stock take was successfully cancelled!', life: 3000 } );
                this.navigateToMain()
              },
              error: errorResponse => this.messageService.add( { severity: 'error', summary: 'Error occurred!', life: 3000 } )
        })  
        }
    })
  }
}
  navigateToMain(){
    if(this.inventory.isMain){
      this.router.navigate([this.venueId, "inventory", this.inventoryId], { queryParams: { activeIndex: 4 }}); 
    }else{
      this.router.navigate([this.venueId, "inventory", this.inventoryId], { queryParams: { activeIndex: 3 }}); 
    }
  }
  public ngOnDestroy(): void {
    if (this.venueIdUpdateSubscription) {
      this.venueIdUpdateSubscription.unsubscribe();
    }
  }
  
}
